// extracted by mini-css-extract-plugin
export var text = "_69-0";